import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    connect() {

    }

    turbo_reload() {
        const urlTemplate = this.element.dataset.turboreloadurl;
        const frameId = this.element.dataset.turbosrc;
        const frame = document.getElementById(frameId);

        frame.innerHTML = '';
        frame.src = urlTemplate;
    }
}
